import MatomoTracker from '@datapunt/matomo-tracker-js';
function createInstance(params) {
    return new MatomoTracker(params);
}
export default createInstance;
